<ion-list class="ion-no-padding">
  @for (item of items; track $index) {
    <ion-item
      lines="full"
      button
      detail="false"
      [disabled]="item.isDisabled"
      (click)="itemClick.emit(item)"
    >
      <ion-label class="ion-text-wrap">
        <h2>
          {{ item.name | translate }}
        </h2>
        <p>{{ item.description | translate }}</p>
      </ion-label>
      <ion-button slot="end" (click)="itemClick.emit(item)">
        @if (item.canBuy) {
          {{ 'shop_buy' | translate }}
          <ion-icon slot="end" name="bag-outline"></ion-icon>
        } @else {
          {{ 'shop_activate' | translate }}
          <ion-icon slot="end" name="checkmark-circle-outline"></ion-icon>
        }
      </ion-button>
    </ion-item>
  }
</ion-list>
